import { Clock } from 'lucide-react';

import { useCapability } from '../../../hooks/use-capability';

/**
 * Window24hBanner — Item 27 (Brief 2A §3.7, ADR-127).
 *
 * Banner ADVISORY no Composer quando a janela de 24h Meta fechou (derivação
 * client-side v1 — `useWindow24h`). Não trava o composer: o Engine é o
 * enforcer (envio livre falha `outside-24h-window`). CTA abre o
 * TemplateSelectorModal — gated pela cap `initiate-proactive-conversation`
 * (a mesma do endpoint de templates reusado; atendente tem, ADR-132).
 */
export function Window24hBanner({
  reason,
  onOpenSelector,
}: {
  reason: 'no-inbound' | 'expired';
  onOpenSelector: () => void;
}): JSX.Element {
  const canUseTemplates = useCapability('initiate-proactive-conversation');
  return (
    <div className="window24h-banner" role="status" data-testid="window24h-banner">
      <Clock size={14} aria-hidden className="window24h-banner__icon" />
      <div className="window24h-banner__text">
        <strong>Janela de 24h do WhatsApp fechada.</strong>{' '}
        {reason === 'no-inbound'
          ? 'O cliente ainda não respondeu nesta conversa — mensagens livres não serão entregues.'
          : 'A última mensagem do cliente tem mais de 24h — mensagens livres não serão entregues.'}{' '}
        {!canUseTemplates && 'Solicite um template aprovado ao gestor.'}
      </div>
      {canUseTemplates && (
        <button
          type="button"
          className="btn btn--sm window24h-banner__cta"
          onClick={onOpenSelector}
        >
          Enviar template
        </button>
      )}
    </div>
  );
}
